import { render, staticRenderFns } from "./ActionCardWidget.vue?vue&type=template&id=1330fb18&"
import script from "./ActionCardWidget.vue?vue&type=script&lang=js&"
export * from "./ActionCardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports